import { Button } from '@affine/component';
import {
  AuthContainer,
  AuthContent,
  AuthHeader,
  SignInPageContainer,
} from '@affine/component/auth-components';
import { useI18n } from '@affine/i18n';

import * as style from './oauth-error.css';

export const OAuthErrorPage = ({
  onRetry,
  onBack,
}: {
  onRetry: () => void;
  onBack: () => void;
}) => {
  const t = useI18n();

  return (
    <SignInPageContainer>
      <div className={style.pageContent}>
        <AuthContainer>
          <AuthHeader title={t['com.affine.auth.toast.title.failed']()} />
          <AuthContent>
            <p className={style.message} role="alert">
              {t['error.INTERNAL_SERVER_ERROR']()}
            </p>
            <div className={style.actions}>
              <Button
                block
                size="extraLarge"
                variant="primary"
                onClick={onRetry}
              >
                Continue with FydeOS
              </Button>
              <Button block size="extraLarge" variant="plain" onClick={onBack}>
                {t['com.affine.invitation.account-mismatch.back-to-affine']()}
              </Button>
            </div>
          </AuthContent>
        </AuthContainer>
      </div>
    </SignInPageContainer>
  );
};
